import React from 'react';

import { Display } from '@rover/kibble/core';
import { Props as DisplayProps } from '@rover/kibble/core/Display';
import { Spacing } from '@rover/kibble/styles';
import LinkOrganizer from '@rover/react-lib/src/components/lists/LinkOrganizer';
import { ServiceLinkWithName } from '@rover/react-lib/src/redux/ducks/serviceLinks.duck';
import type { Anchor } from '@rover/types/src/Anchor';
import { ServiceLandingEnum } from '@rover/types/src/ServiceLanding';

type Props = {
  serviceLandingType: ServiceLandingEnum | null;
  serviceLinksWithDisplayName: ServiceLinkWithName[];
  children?: React.ReactNode;
};

const ServiceLandingServices = ({
  serviceLinksWithDisplayName,
  serviceLandingType,
  children,
}: Props): JSX.Element => {
  const serviceLinkAnchors = serviceLinksWithDisplayName
    .filter(({ type }) => type !== serviceLandingType)
    .map(({ href, name }): Anchor => ({ title: name, href: href || '' }))
    .sort((a, b) => a.title.localeCompare(b.title));

  return (
    <>
      {children}
      <LinkOrganizer
        links={serviceLinkAnchors}
        columns={[2, 3, serviceLinkAnchors.length === 13 ? 3 : 4]}
        columnGap={Spacing.S.toString()}
        lineSpacing="large"
      />
    </>
  );
};

ServiceLandingServices.Display = (props: DisplayProps): JSX.Element => (
  <Display
    marginTop="3x"
    marginBottom="2x"
    size="500"
    responsive={false}
    textAlign="center"
    {...props}
  >
    {props.children}
  </Display>
);

export default ServiceLandingServices;
